import { safeLocalStorage } from "@utilities/localStorage";

let _sessionId = crypto.randomUUID();
/* Gets session based on sessionization time. If sessionization is 0, it means
  that we want to have one session for the whole duration of the player. Otherwise
  we want to preserve session for sessionization time. If user refreshes the page
  after session expired, new session is created. If user refreshes the page
  before session expired, session is preserved. */
export const getSessionId = (sessionization: number | null) => {
  if (sessionization === null || sessionization === 0) {
    return _sessionId;
  }

  let session = safeLocalStorage.getItem("elevenLabsAudioNativePlayerSessionId");
  const currUnix = Date.now();

  // If session is not present, create new session.
  if (!session) {
    session = `${_sessionId}.${currUnix}`;
    safeLocalStorage.setItem("elevenLabsAudioNativePlayerSessionId", session);
    return _sessionId;
  }

  const [id, timestamp] = session.split(".");
  // If session is older than sessionization time and it's a reload, create new session.
  if (currUnix - Number.parseInt(timestamp, 10) > sessionization * 60 * 1000 && id !== _sessionId) {
    const newSessionId = crypto.randomUUID();
    _sessionId = newSessionId;
    session = `${newSessionId}.${currUnix}`;
    safeLocalStorage.setItem("elevenLabsAudioNativePlayerSessionId", session);
    return newSessionId;
  }

  // Otherwise continue with current session but update timestamp.
  session = `${id}.${currUnix}`;
  safeLocalStorage.setItem("elevenLabsAudioNativePlayerSessionId", session);
  // if there was reload but session is still valid, we want to preserve it.
  _sessionId = id;
  return id;
};

export const getPlayedDuration = (sessionization: number | null) => {
  const playedDuration = safeLocalStorage.getItem("elevenLabsAudioNativePlayerPlayedDuration");
  if (!playedDuration) {
    return 0;
  }
  const [id, duration] = playedDuration.split("=");
  if (id !== getSessionId(sessionization)) {
    return 0;
  }
  return Number.parseInt(duration, 10);
};

export const setPlayedDuration = (sessionization: number | null, duration: number) => {
  safeLocalStorage.setItem("elevenLabsAudioNativePlayerPlayedDuration", `${getSessionId(sessionization)}=${duration}`);
};

// Client ID is stored in local storage and is used to identify user.
export const getClientId = () => {
  let clientId = safeLocalStorage.getItem("elevenLabsAudioNativePlayerClientId");
  if (!clientId) {
    clientId = `${crypto.randomUUID()}.${Math.floor(Date.now() / 1000)}`;
    safeLocalStorage.setItem("elevenLabsAudioNativePlayerClientId", clientId);
  }
  return clientId;
};
